import { Navigate, Route, Routes } from "react-router-dom";

import Login from "./components/Login";
import CoursePage from "./screens/CoursePage";
import Reset from "./components/Reset";
import AuthLayout from "./screens/AuthLayout";
import Registration from "./components/Registration";
import AccountPage from "./screens/AccountPage";
import AccountInfo from "./components/AccountInfo";
import AmazonPage from "./screens/AmazonPage";
import Chat from "./components/Chat/Chat";
import ProtectedRoute from "./utils/protectedRoute";
import EditModule from "./components/AdminPanel/EditModule";
import Users from "./components/AdminPanel/Users";
import EditLesson from "./components/AdminPanel/EditLesson";
import TriaLessonPage from "@/screens/TriaLessonPage.jsx";
import { getCourseRoutes } from "@/screens/CourseRoutes.jsx";
import AmazonInvestPage from "./screens/AmazonInvestPage";

function App() {
  return (
    <Routes>
      <Route
        path="/auth/sign-up"
        element={
          <AuthLayout>
            <Registration />
          </AuthLayout>
        }
      />
      <Route
        path="/auth/sign-in"
        element={
          <AuthLayout>
            <Login />
          </AuthLayout>
        }
      />
      <Route
        path="/auth/reset"
        element={
          <AuthLayout>
            <Reset />
          </AuthLayout>
        }
      />

      <Route
        path="/course/*"
        element={
          <ProtectedRoute>
            <CoursePage />
          </ProtectedRoute>
        }
      >
        <Route path="trial" element={<TriaLessonPage />}>
          {getCourseRoutes("trial")}
        </Route>

        <Route path="amazon" element={<AmazonPage />}>
          {getCourseRoutes("amazon", true)}
        </Route>
        <Route path="amazonInvest" element={<AmazonInvestPage />}>
          {getCourseRoutes("amazonInvest", true)}
        </Route>
      </Route>

      <Route
        path="/users"
        element={
          <ProtectedRoute>
            <Users />
          </ProtectedRoute>
        }
      ></Route>

      <Route
        path="/account/*"
        element={
          <ProtectedRoute>
            <AccountPage />
          </ProtectedRoute>
        }
      >
        <Route path="general" element={<AccountInfo />} />
      </Route>

      {/* Защита чата */}
      <Route
        path="/chat"
        element={
          <ProtectedRoute>
            <Chat />
          </ProtectedRoute>
        }
      />
      <Route
        path="/edit-module"
        element={
          <ProtectedRoute>
            <EditModule />
          </ProtectedRoute>
        }
      ></Route>
      <Route path="/edit-module/lesson/:id" element={<EditLesson />}></Route>

      <Route
        path="*"
        element={<Navigate to="/course/trial/lessons" replace />}
      />
    </Routes>
  );
}

export default App;
